// Simple "Start Case" conversion that preserves acronyms.
// @see https://stackoverflow.com/a/6229124
export function startCase(string: string): string {
  return string
    // Insert a space between lower & upper.
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    // Space before last upper in a sequence followed by lower.
    .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
    // Uppercase the first character.
    .replace(/^./, (str) => str.toUpperCase());
}
